import { ptBR } from 'date-fns/locale'
import { useNavigate } from 'react-router-dom'
import IconNoData from '@assets/icons/nodata.svg'
import { Stack, Typography } from '@mui/material'
import { HeaderSelect } from './components/Header'
import { addDays, subDays, format } from 'date-fns'
import { getDate } from '@utils/functions/dates/dates'
import { useCallback, useState, useEffect } from 'react'
import { Container, Header, Content } from './styles'
import { DateSinglePicker } from './components/DateSinglePicker'
import CardEventComponent from '@components/organisms/Cards/Event/Event'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import { Button, Input } from '@components/atoms'
import AgendaSwitch from './components/AgendaSwitch'
import { TITLE, SUBTITLE } from './types'
import { isMobile } from 'react-device-detect'
import { FileDownloadOutlined } from '@mui/icons-material'
import { ExportPropositionModal } from '@containers/ExportPropositionModal'

function EventsCalendarList(props) {
  const navigate = useNavigate()
  const {
    data,
    headerLocation,
    handleUpdateSearch,
    tab,
    setTab,
  } = props

  const [period, setPeriod] = useState({
    start: getDate(new Date()),
    end: addDays(getDate(new Date()), 30),
  })
  const [textSearch, setTextSearch] = useState('')

  const handleNextPeriod = useCallback(() => {
    setPeriod({
      start: period.end,
      end: addDays(period.end, 30),
    })
  }, [period])

  const handlePreviousPeriod = useCallback(() => {
    setPeriod({
      start: subDays(period.start, 30),
      end: period.start,
    })
  }, [period])

  const handleChangePeriod = useCallback((date) => {
    if (!date) return

    setPeriod({
      start: date,
      end: addDays(date, 30),
    })
  }, [])

  useEffect(() => {
    handleUpdateSearch({
      [`buckets.events.limit`]: 10,
      [`buckets.events.filter.date.from`]: format(period.start, 'yyyy-MM-dd'),
      [`buckets.events.filter.date.to`]: format(period.end, 'yyyy-MM-dd'),
      [`buckets.events.sort`]: 'older',
      [`buckets.events.filter.text`]: textSearch,
    })
  }, [period, textSearch])

  return (
    <Container style={{ marginBottom: 0, paddingBottom: '48px' }}>
      <Header location={headerLocation}>
        <Stack direction={'row'}>
          <KeyboardArrowLeft stroke="#606162" onClick={handlePreviousPeriod} />
          <KeyboardArrowRight stroke="#606162" onClick={handleNextPeriod} />
        </Stack>
        <DateSinglePicker
          text={`${format(period.start, 'dd MMM', { locale: ptBR })} a
            ${format(period.end, 'dd MMM yyyy', { locale: ptBR })}`}
          onChange={handleChangePeriod}
        />

        <HeaderSelect />
        {tab && setTab && <AgendaSwitch tab={tab} setTab={setTab}/>}
        {tab && setTab && <Input
          size="tiny"
          type="search"
          id="panel-search"
          label="Pesquisar"
          value={textSearch}
          sx={{ width: '262px',
            maxWidth: '100%',
            [`& .MuiFormLabel-root`]: {
              color: '#606162',
            }}}
          onChange={(e) =>
            setTextSearch(e.target.value)
          }
        />}
      </Header>
      {tab && setTab &&
        <Stack direction="row" sx={{justifyContent: "space-between", marginLeft: "36px", marginBottom: "24px"}}>
          <Stack direction="column" spacing={2}>
            <Typography
              variant="$font-title-4"
              color="$color-text-primary"
            >
              {TITLE[tab]}
            </Typography>
            <Typography
              variant="$font-body-base"
              color="$color-text-secondary"
            >
              {SUBTITLE[tab]}
            </Typography>
          </Stack>
          {!isMobile && (
              <Button
                disabled={true}
                variant="text"
                text="Exportar"
                // textcolor="black"
                startIcon={<FileDownloadOutlined />}
                onClick={() =>
                  openModal(
                    <ExportPropositionModal
                      monitorId={String(id)}
                      monitorName={monitor?.data?.name || 'monitor'}
                    />
                  )
                }
              />
            )}
        </Stack>
      }

      <Content style={{ gap: '12px' }}>
        {data?.length === 0 && (
          <Stack direction="column" gap={1} sx={{ marginTop: 10, justifyContent: 'center', alignItems: 'center' }}>
            <img src={IconNoData} alt="No Data" height={30} />
            <Typography variant="$font-title-5" color="text.disabled">
              No Data
            </Typography>
          </Stack>
        )}

        {data?.map((event, index) => (
          <CardEventComponent event={event} key={index} handleOpenModalDetailsEvent={()=> navigate(`/events/${event.id}`)} />
        ))}
      </Content>
    </Container>
  )
}

export default EventsCalendarList
